// 后端
// export const baseUrl = 'http://192.168.1.80:8001'

export const baseUrl = 'https://xxx.com'
export default {
    baseUrl,
}